export { default } from './es/icons/TopHoverFilled';